import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import "./RegisterForm.css";
import DefaultInput from "../../components/form/DefaultInput";
import DefaultSelect from "../../components/form/DefaultSelect";
import {
	Button,
	Checkbox,
	Divider,
	Modal,
	Result,
	Select,
	Upload,
	message,
} from "antd";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import DefaultPhoneInput from "../../components/form/DefaultPhoneInput";
import DefaultSwitch from "../../components/form/DefaultSwitch";
import {
	fetchZonesCached,
	getConfigurationValueCached,
} from "../../lib/cachedLookups";
import {
	useConfiguration,
	useConfigurationNumber,
} from "../../hooks/useConfiguration";
import { ConfigurationId } from "../../types/Lookups";
import {
	CheckCircleTwoTone,
	CloseCircleTwoTone,
	UploadOutlined,
} from "@ant-design/icons";
import DefaultPasswordInput from "../../components/form/DefaultPasswordInput";
import { usernamePasswordValidate } from "../../types/UsernamePasswordValidate";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import L, { Icon, LatLngTuple } from "leaflet";
import { userRoles } from "../../types/enums";
import useLang from "../../hooks/useLang";
import { CONFIG } from "../../config";
import AddressSelect from "../../components/form/AddressSelect";

const pdfReadMore = "/Kontrata.pdf";

interface IUserInsertData {
	[name: string]: any;
}

const { Option } = Select;
const NOMINATIM_BASE_URL = "https://nominatim.openstreetmap.org/search?";
const RegisterForm = () => {
	const [submited, setSubmited] = useState<boolean>(false);
	const [firstLastName, setFirstLastName] = useState<string>("");
	const [email, setEmail] = useState<string>("");
	const [username, setUsername] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [confirmPassword, setConfirmPassword] = useState<string>("");
	const [phone, setPhone] = useState<string>("");
	const [address, setAddress] = useState<string>("");
	const [identificationNumber, setIdentificationNumber] = useState<
		string | undefined
	>();
	const [country, setCountry] = useState<string | undefined>();
	const [city, setCity] = useState<string | undefined>();
	const [temporaryLinkValidationData, setTemporaryLinkValidationData] =
		useState<any>([]);
	const [countryDropDown, setCountryDropDown] = useState<any>([]);
	const [cityDropDown, setCityDropDown] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);
	const [countryLabel, setCountryLabel] = useState<string>("xk");
	const [cityLabel, setCityLabel] = useState<string | undefined>("");
	const [apiLatitude, setApiLatitude] = useState<number | null>();
	const [apiLongitude, setApiLongitude] = useState<number | null>();
	const [sectionId, setSectionId] = useState<number | null>(null);
	const [finalAddress, setFinalAddress] = useState<string>("");
	const [checkbox, setCheckbox] = useState<boolean>(false);
	const [businessPhoneNumber, setBusinessPhoneNumber] = useState<string>("");
	const [businessNumber, setBusinessNumber] = useState<string>("");
	const [businessName, setBusinessName] = useState<string>("");
	const [latitude, setLatitude] = useState<number | null>(null);
	const [longitude, setLongitude] = useState<number | null>(null);
	const [mapCenter, setMapCenter] = useState<LatLngTuple | null>([
		42.6026, 20.903,
	]);

	const markerRef = useRef(null);
	const [position, setPosition] = useState<any>(null);
	const [adressPosition, setAddressPosition] = useState<any>(null);
	const [geoData, setGeoData] = useState<any>();

	const [cash, setCash] = useState<boolean>(true);
	const [bank, setBank] = useState<boolean>(false);
	const [vat, setVat] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);

	const [countryError, setCountryError] = useState<boolean>(false);
	const [cityError, setCityError] = useState<boolean>(false);
	const [addressError, setAddressError] = useState<boolean>(false);
	const [openPhoneCodeConfirmationModal, setOpenPhoneCodeConfirmationModal] =
		useState<boolean>(false);
	const [phoneCode, setPhoneCode] = useState<string>("");
	const phonePrefix = useConfiguration(ConfigurationId.PhonePrefix) ?? "";
	const personalIdLength = useConfigurationNumber(
		ConfigurationId.PersonalIdLength
	);
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const [businessSelectedFiles, setBusinessSelectedFiles] = useState<File[]>(
		[]
	);
	const phoneLength =
		useConfigurationNumber(ConfigurationId.PhoneLength) ?? 0;
	const [allSections, setAllSections] = useState<any>([]);
	const [showNumberInOrder, setShowNumberInOrder] = useState(false);
	useEffect(() => {
		setCountriesAndCities();
	}, []);

	const handleConfirmPasswordChange = (e: any) => {
		setConfirmPassword(e.target.value);
		if (password === e.target.value) {
			setError(false);
		}
	};

	const handleBlur = useCallback(() => {
		if (password !== confirmPassword) {
			message.error("Fjalëkalimet nuk përputhen.");
			setError(true);
		} else {
			setError(false);
		}
	}, [confirmPassword, password]);

	const setCountriesAndCities = async () => {
		const [zones, countryId] = await Promise.all([
			fetchZonesCached(),
			getConfigurationValueCached(ConfigurationId.Country),
		]);
		if (zones) {
			const countries = zones
				.filter(
					(item: any) => item.levelId === 1 && item.id == countryId
				)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCountryDropDown(countries);
			const filteredCities = zones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCityDropDown(filteredCities);
			const cities = zones?.filter((item: any) => item.levelId === 2);
			setCities(cities);
			const sections = zones?.filter((item: any) => item.levelId === 3);
			setAllSections(sections);
		}
	};

	const validateInsertedData = (data: any) => {
		const {
			firstName,
			lastName,
			phone,
			address,
			username,
			password,
			identificationNumber,
			sectionId,
		} = data;

		if (!firstName) {
			toast.error(strings.firstNameErrorAlert);
			return false;
		}
		if (!lastName) {
			toast.error(strings.lastNameErrorAlert);
			return false;
		}
		if (!phone) {
			toast.error(strings.phoneErrorAlert);
			return false;
		}
		if (!address) {
			toast.error(strings.addressErrorAlert);
			return false;
		}
		if (!username) {
			toast.error(strings.usernameErrorAlert);
			return false;
		}
		if (!password) {
			toast.error(strings.passwordErrorAlert);
			return false;
		}
		if (!identificationNumber) {
			toast.error(strings.identificationNumberErrorAlert);
			return false;
		}
		if (identificationNumber.length !== personalIdLength) {
			toast.error(
				strings.identificationNumberLengthErrorAlert + personalIdLength
			);
			return false;
		}
		if (!sectionId) {
			toast.error("Error zona");
			return false;
		}

		return true;
	};

	const fetchGeoData = useCallback(async (latitude: any, longitude: any) => {
		try {
			const response = await api.get("External/get-geo-data", {
				params: {
					lng: longitude,
					lat: latitude,
					category: CONFIG?.zoneMbledhs ?? "",
				},
			});
			if (response.status === 200) {
				const result = response?.data;
				const section = Number(result.geofences[0]?.name);
				setSectionId(section);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	const onCountrySelect = (e: any) => {
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setAddress("");
		setSectionId(0);
		setCountry(e);
		if (e === 1) {
			setCountryLabel("xk");
		} else if (e === 2) {
			setCountryLabel("al");
		} else if (e === 3) {
			setCountryLabel("mk");
		}
		setCity("");
		setCityLabel("");
		setAddress("");
		setFinalAddress("");
		// setData([]);
	};

	const onCitySelect = (value: any) => {
		if (value?.value) {
			const id = value.value;
			setCity(id);
			setCityLabel(value?.label);
			setAddress("");
			// setData([]);
		} else {
			setCity("");
			setCityLabel("");
			setAddress("");
			// setData([]);
		}
	};

	const handleChange = (address: any) => {
		const selectedLocation = address;
		if (selectedLocation) {
			const lat = selectedLocation.lat;
			const lng = selectedLocation.lng;
			setAddressPosition([lat, lng]);
			setPosition([lat, lng]);
			setApiLatitude(lat);
			setApiLongitude(lng);
			fetchGeoData(lat, lng);
			setAddress(selectedLocation.label ?? "");
		}
	};

	const validateUsernameAndEmail = async () => {
		try {
			const response = await api.get("User/validate-username-email", {
				params: { username: username, email: email ? email : null },
			});
			if (response.status === 200) {
				const result = response.data;
				if (result.message === "Valid") {
					return true;
				} else {
					toast.error(`${result.message}`);
					return false;
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const register = async () => {
		const fullNameArray = firstLastName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		const otpNumber = {
			numbers: [phone],
		};

		const validation = usernamePasswordValidate(username, password);

		if (!validation.valid) {
			toast.error(validation.message);
			return;
		}

		if (!phone.startsWith(phonePrefix) || phone.length > phoneLength) {
			toast.error(
				`Numri i telefonit duhet te filloje me ${phonePrefix} dhe te kete ${phoneLength} numra`
			);
			return;
		}

		if (selectedFiles.length < 2) {
			toast.error(strings.photoSelectError);
			return;
		}

		if (businessName.length > 0 && businessSelectedFiles.length <= 0) {
			toast.error(strings.photoBusinessSelectError);
			return;
		}
		if (businessName.length > 0 && !businessNumber) {
			toast.error(strings.businessNumberRequiredError);
			return;
		}

		const existingSection = allSections?.some(
			(item: any) => sectionId !== null && item.id === sectionId
		);

		if (!existingSection) {
			toast.error(strings.zoneNotRegisteredError);
			return;
		}
		const isUnique = await validateUsernameAndEmail();
		if (!isUnique) {
			return false;
		}

		const data = {
			firstName: firstName,
			lastName: lastName,
			phone: phone,
			address: address,
			username: username,
			email: email,
			password: password,
			userRoleId: userRoles.CLIENT,
			identificationNumber: identificationNumber,
			sectionId: sectionId,
			longitude: apiLongitude?.toString(),
			latitude: apiLatitude?.toString(),
			packagePriceIncudesTaxes: vat,
			bankPackageTransportPayment: bank,
			cashPackageTransportPayment: cash,
			businessName: businessName,
			businessNumber: businessNumber,
			businessNr: businessPhoneNumber,
			status: false,
			approved: false,
		};
		if (validateInsertedData(data)) {
			const resendOtp = await checkPhoneNumber();
			if (!resendOtp) {
				try {
					const response = await api.post(
						"OTP/insert-otp",
						otpNumber
					);
					if (response.data.success === true) {
						setOpenPhoneCodeConfirmationModal(true);
					}
				} catch (error) {
					console.log(error);
					return;
				}
			} else {
				setOpenPhoneCodeConfirmationModal(true);
			}
		} else {
			return;
		}
		return;
	};

	const registerClient = async () => {
		const fullNameArray = firstLastName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");
		const formData = new FormData();

		const extractedFiles = selectedFiles.map(
			(file: any) => file?.originFileObj
		);
		const extractedBusinessFiles = businessSelectedFiles.map(
			(file: any) => file?.originFileObj
		);

		extractedFiles.forEach((file: any) => {
			formData.append("images", file);
		});

		extractedBusinessFiles.forEach((file: any) => {
			formData.append("businessImage", file);
		});

		const data: IUserInsertData = {
			firstName: firstName,
			lastName: lastName,
			phone: phone,
			address: address,
			username: username,
			email: email,
			password: password,
			userRoleId: userRoles.CLIENT,
			identificationNumber: identificationNumber,
			sectionId: sectionId,
			longitude: apiLongitude?.toString(),
			latitude: apiLatitude?.toString(),
			packagePriceIncudesTaxes: vat,
			bankPackageTransportPayment: bank,
			cashPackageTransportPayment: cash,
			businessName: businessName,
			businessNumber: businessNumber,
			businessNr: businessPhoneNumber,
			status: false,
			approved: false,
			code: phoneCode,
			showNumberInOrder: showNumberInOrder,
		};

		if (!phone.startsWith(phonePrefix) && phone.length !== 11) {
			toast.error(strings.phoneNumberShouldStartWith + phonePrefix);
			return;
		}
		for (const key in data) {
			formData.append(key, data?.[key]?.toString() ?? "");
		}
		try {
			const response = await api.post(
				"User/main-register-test",
				formData
			);
			if (response.status === 200) {
				toast.success("Aplikimi u krye me sukses!");
				setSelectedFiles([]);
				setSubmited(true);
				return;
			} else {
				toast.error(strings.genericErrorOccurred);
			}
		} catch (error: any) {
			toast.error(error?.response?.data);
		}
	};

	const eventHandlers = useMemo(
		() => ({
			dragend() {
				const marker = markerRef.current;
				if (marker != null) {
					const latLng = marker["_latlng"];
					setPosition(latLng);
					setApiLatitude(latLng["lat"]);
					setApiLongitude(latLng["lng"]);
					fetchGeoData(latLng["lat"], latLng["lng"]);
				}
			},
		}),
		[]
	);

	const customIcon = new Icon({
		iconUrl: require("../../assets/pin.png"),
		iconSize: [38, 38],
	});

	const ResetCenterView = (props: any) => {
		const { selectedPosition } = props;
		const { addressPosition } = props;
		const map = useMap();
		useEffect(() => {
			if (selectedPosition === 1) {
				map.setView(L.latLng(42.6026, 20.903), map.getZoom(), {
					animate: true,
				});
			} else if (selectedPosition === 2) {
				map.setView(L.latLng(41.1533, 20.1683), map.getZoom(), {
					animate: true,
				});
			} else if (selectedPosition === 3) {
				map.setView(L.latLng(41.6086, 21.7453), map.getZoom(), {
					animate: true,
				});
			}
			if (addressPosition) {
				map.setView(L.latLng(addressPosition), 15, {
					animate: true,
				});
			}
		}, [map, selectedPosition]);

		return null;
	};
	const phoneNumberChange = (e: any) => {
		const digitsOnly = e.target.value.replace(/\D+/g, "");
		setPhone(digitsOnly);
	};

	const checkPhoneNumber = async () => {
		if (!phone) {
			toast.error(
				"Ju lutem shenoni Kodin te cilin e keni pranuar ne telefon"
			);
			return;
		}
		try {
			const response = await api.get("OTP/select-otp", {
				params: { phoneNumber: phone },
			});
			if (response.status === 200) {
				return response?.data;
			}
		} catch (error) {
			console.log(error);
		}
	};

	const checkPhoneCode = async () => {
		if (!phoneCode) {
			toast.error(
				"Ju lutem shenoni Kodin te cilin e keni pranuar ne telefon"
			);
			return;
		}
		try {
			const response = await api.get("OTP/select-otp", {
				params: { code: phoneCode, phoneNumber: phone },
			});
			if (response.status === 200 && response?.data === true) {
				clearePhoneCodeModalState();
				registerClient();
			} else if (response?.data === false) {
				toast.error("Gabim");
				clearePhoneCodeModalState();
				return false;
			}
		} catch (error) {
			console.log(error);
		}
	};

	const clearePhoneCodeModalState = () => {
		setOpenPhoneCodeConfirmationModal(false);
		setPhoneCode("");
	};

	const changeSwitch = () => {
		setCash((prevState) => !prevState);
		setBank((prevState) => !prevState);
	};

	const changeShowNumberInOrder = () => {
		setShowNumberInOrder((prevState) => !prevState);
	};

	const handleFileChange = (event: any) => {
		if (event.fileList?.length) {
			const file: any = Array.from(event.fileList);
			setSelectedFiles(file);
		}
	};

	const handleFileChangeBusieness = (event: any) => {
		if (event.fileList?.length) {
			const file: any = Array.from(event.fileList);
			setBusinessSelectedFiles(file);
		}
	};

	const clearCitySelection = () => {
		setCity("");
		setCityLabel("");
		setAddress("");
		setFinalAddress("");
		setSectionId(0);
	};

	const { strings } = useLang("registerForm");
	return (
		<>
			{!submited ? (
				<div className="registerContainer">
					<div className="registerForm">
						<h1 className="registerTitle">
							{strings?.registerTitle}
						</h1>
						<div className="registerInputs">
							<div className="registerInputsFirst">
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.firstLastName.label}
									placeholder={
										strings?.inputs.firstLastName
											.placeholder
									}
									value={firstLastName}
									onChange={(e) =>
										setFirstLastName(e.target.value)
									}
								/>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.phone.label}
									placeholder={
										strings?.inputs.phone.placeholder
									}
									value={phone}
									onChange={(e) => phoneNumberChange(e)}
								/>
								<DefaultInput
									className="registerInput"
									label={
										strings?.inputs.identificationNumber
											.label
									}
									value={identificationNumber}
									onChange={(e) =>
										setIdentificationNumber(e.target.value)
									}
									placeholder={
										strings?.inputs.identificationNumber
											.placeholder
									}
								/>

								<DefaultInput
									className="registerInput"
									label={strings?.inputs.username.label}
									placeholder={
										strings?.inputs.username.placeholder
									}
									value={username}
									onChange={(e) =>
										setUsername(e.target.value)
									}
								/>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.email.label}
									placeholder={
										strings?.inputs.email.placeholder
									}
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
								<DefaultPasswordInput
									className="registerInput"
									label={strings?.inputs.password.label}
									value={password}
									placeholder={
										strings?.inputs.password.placeholder
									}
									onChange={(e) =>
										setPassword(e.target.value)
									}
									onBlur={handleBlur}
									allowClear={true}
									labelClass={"mb-0"}
								/>
								<DefaultInput
									label={
										strings?.inputs.confirmPassword.label
									}
									className="registerInput"
									value={confirmPassword}
									onChange={handleConfirmPasswordChange}
									onBlur={handleBlur}
									placeholder={
										strings?.inputs.confirmPassword
											.placeholder
									}
									status={error ? "error" : ""}
									type="password"
									suffix={
										error ? (
											<CloseCircleTwoTone twoToneColor="#ff4d4f" />
										) : (
											<CheckCircleTwoTone twoToneColor="#52c41a" />
										)
									}
									allowClear={true}
								/>
								<DefaultSelect
									className="registerInput"
									onChange={onCountrySelect}
									value={country}
									placeholder={
										strings?.inputs.country.placeholder
									}
									label={strings?.inputs.country.label}
									flexDirection="col"
									alignCenter="start"
									options={countryDropDown}
									allowClear
									status={countryError ? "error" : ""}
								/>
								<DefaultSelect
									className="registerInput"
									placeholder={
										strings?.inputs.city.placeholder
									}
									value={city}
									onChange={onCitySelect}
									label={strings?.inputs.city.label}
									flexDirection="col"
									alignCenter="start"
									options={cityDropDown}
									allowClear
									onClear={clearCitySelection}
									labelInValue={true}
									status={cityError ? "error" : ""}
								/>
								<div className="flex flex-col items-start ">
									<label className="w-42 -mt-1">
										{strings?.inputs.address.label}
									</label>

									<AddressSelect
										onAddressChange={handleChange}
										country={countryLabel}
										selectedAddress={address}
										city={city}
									/>
								</div>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.businessName.label}
									placeholder={
										strings?.inputs.businessName.placeholder
									}
									value={businessName}
									onChange={(e) =>
										setBusinessName(e.target.value)
									}
								/>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.businessNumber.label}
									placeholder={
										strings?.inputs.businessNumber
											.placeholder
									}
									value={businessNumber}
									onChange={(e) =>
										setBusinessNumber(e.target.value)
									}
								/>
								<div className="flex flex-col items-start gap-1">
									<div className="displayPhoneNumber">
										<p>
											{
												strings?.checkboxes
													?.showNumberInOrder
											}
										</p>
										<Checkbox
											checked={showNumberInOrder}
											onChange={changeShowNumberInOrder}
										/>
									</div>
								</div>

								<DefaultPhoneInput
									className="registerInputPhone"
									label={strings?.inputs.businessPhone.label}
									placeholder={
										strings?.inputs.businessPhone
											.placeholder
									}
									initialPhoneNumber={businessPhoneNumber}
									onPhoneNumberChange={(v) =>
										setBusinessPhoneNumber(v)
									}
								/>
								<div className="flex flex-col items-start justify-start w-auto gap-2  gap-4">
									<p>
										{strings?.switches.postalServicePayment}
									</p>
									<div className="flex flex-row justify-around gap-2">
										<DefaultSwitch
											label={strings?.switches.cash}
											checked={cash}
											onChange={changeSwitch}
										/>
										<DefaultSwitch
											label={strings?.switches.bank}
											checked={bank}
											onChange={changeSwitch}
										/>
									</div>
								</div>

								<div className="uploadFilesDiv">
									<div className="flex flex-col">
										<label
											htmlFor="fileInput"
											className="block mb-2"
										>
											{
												strings?.inputs.fileUpload
													.firstInsert
											}
										</label>
										<Upload
											onChange={handleFileChange}
											multiple={true}
											beforeUpload={() => false}
											accept="image/*"
										>
											<Button
												icon={<UploadOutlined />}
												className="buttonUploadFile"
											>
												{
													strings?.inputs.fileUpload
														.choose
												}
											</Button>
										</Upload>
									</div>
									<div className="flex flex-col">
										<label
											htmlFor="fileInput"
											className="block mb-2"
										>
											{
												strings?.inputs.fileUpload
													.secondInsert
											}
										</label>
										<Upload
											onChange={handleFileChangeBusieness}
											beforeUpload={() => false}
										>
											<Button
												icon={<UploadOutlined />}
												className="buttonUploadFile"
											>
												{
													strings?.inputs.fileUpload
														.choose
												}
											</Button>
										</Upload>
									</div>
								</div>
							</div>
							<div className="registerFormMap">
								<div>
									{mapCenter !== null && (
										<MapContainer
											center={mapCenter}
											zoom={7.5}
											scrollWheelZoom={false}
											className="mapContainerRegisterForm"
										>
											<TileLayer
												attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
												url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
											/>
											{position !== null && (
												<>
													<Marker
														draggable={true}
														position={position}
														icon={customIcon}
														eventHandlers={
															eventHandlers
														}
														ref={markerRef}
													>
														<Popup
															minWidth={90}
														>{`Position${position}`}</Popup>
													</Marker>
												</>
											)}
											<ResetCenterView
												selectedPosition={country}
												addressPosition={adressPosition}
											/>
										</MapContainer>
									)}
								</div>
							</div>
						</div>
						<div className="flex flex-wrap  gap-8">
							<div className="flex flex-row justify-center items-center gap-4">
								<Checkbox
									onChange={(e) =>
										setCheckbox(e.target.checked)
									}
									value={checkbox}
								/>
								<p className="text-wrap">
									{strings?.checkboxText}
									<a
										href={pdfReadMore}
										target="_blank"
										rel="noreferrer"
										className="text-sky-600"
									>
										{strings?.readMore}
									</a>
								</p>
							</div>
						</div>
						<div className="lastDiv">
							<Button
								className="registerButton"
								onClick={register}
								disabled={!checkbox}
							>
								{strings?.applyButton}
							</Button>
						</div>
					</div>
				</div>
			) : (
				<div className="flex justify-center items-center p-10">
					<div className="bg-white w-2/4">
						<Result
							status="success"
							title={strings?.success?.title}
							subTitle={strings?.success.subTitle}
							className="bg-white"
						/>
					</div>
				</div>
			)}
			<Modal
				open={openPhoneCodeConfirmationModal}
				title={strings?.phoneConfirmation?.title}
				onCancel={clearePhoneCodeModalState}
				footer={() => (
					<div className="flex  items-center justify-center">
						<Button
							className="registerButton"
							onClick={checkPhoneCode}
						>
							{strings?.phoneConfirmation.confirmButton}
						</Button>
					</div>
				)}
			>
				<Divider />
				<div className="flex  items-start justify-start pb-6">
					<p className="text-base antialiased">
						{strings?.phoneConfirmation.subtitle} <b>+{phone}</b>
					</p>
				</div>
				<div className="flex flex-col gap-4 items-center justify-center">
					<DefaultInput
						label={strings?.phoneConfirmation.phoneCode}
						value={phoneCode}
						className="registerInput"
						onChange={(e) => setPhoneCode(e.target.value)}
					/>
				</div>
			</Modal>
		</>
	);
};

export default RegisterForm;
